var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioButtonInactive = function SvgRadioButtonInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 6,
    stroke: "#E6F1F2",
    strokeWidth: 1.5,
    opacity: 0.25,
    rx: 6
  })));
};
export { SvgRadioButtonInactive as ReactComponent };
export default __webpack_public_path__ + "41ad53044fe98a14b4784be6d1d0c4a7.svg";